// import axios from 'axios';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import 'react-phone-number-input/style.css';
import { handleSendSMS } from '~/utils/api';
import PaveButton from '../reusables/Button';
import PhoneInput from 'react-phone-number-input';
import { PaveColor } from '../components/ConfigStyle';
import { openNotification } from '~/utils/antNotification';
import { checkingEmptyObject } from '~/utils/checkingEmptyObj';
import * as gaActions from '~/state/actions/googleAnal/actions';
import notMobileIcon from '~/themes/default/assets/handmobile.png';
import React, { useState, Fragment, useEffect, useCallback } from 'react';

const findTheme = {
  LITE: 'LITE',
  DEFAULT: 'DEFAULT',
  DEALER_TRACK: 'DEALER_TRACK',
};
const NotMobile = (props) => {
  const { sessionID, gaAction, themeFrom, userDetailsReducer } = props;
  const { browserUserInfo } = userDetailsReducer;
  const [isOk, setisOk] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [isLite, setisLite] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [mobileView, setmobileView] = useState(false);
  const [isTheme, setisTheme] = useState(findTheme.DEFAULT);
  const defaultMess = `PAVE's Notification`;

  const { getDataGA } = gaAction;

  useEffect(() => {
    if (!!themeFrom) {
      if (
        themeFrom === 'CDD' ||
        themeFrom === 'UAC' ||
        themeFrom === 'TDC' ||
        themeFrom === 'TDD'
      ) {
        setisLite(true);
      } else {
        setisLite(false);
        if (themeFrom === 'UAD' || themeFrom === 'CDE' || themeFrom === 'TDT') {
          setisTheme(findTheme.DEALER_TRACK);
        } else {
          setisTheme(findTheme.DEFAULT);
        }
      }
    }
  }, [themeFrom]);

  useEffect(() => {
    const { platform } = !!browserUserInfo && browserUserInfo;
    const { type } = !!platform && platform;
    if (!!type && type === 'mobile') {
      setmobileView(true);
    }
  }, [browserUserInfo]);

  const goBack = () => {
    const eventObj = {
      EventCategory: 'TradeDriver Pave',
      EventAction: sessionID,
      EventLabel: 'Exit from Pave',
    };
    checkingEmptyObject(eventObj) === 'NOT_EMPTY' && getDataGA(eventObj);
    window.history.back();
  };
  const handleChange = (getInputValue) => {
    !!getInputValue && getInputValue !== '' && getInputValue.trim().length >= 10
      ? setsubmit(true)
      : setsubmit(false);
    setInputVal(getInputValue);
  };
  const handleCopyUrl = useCallback(() => {
    var Url = document.getElementById('url-text');
    if (!!Url) {
      Url.value = window.location.href;
      Url.focus();
      Url.select();
      document.execCommand('Copy');
      let copyUrl = Url.value;
      openNotification({
        mess: `Copied: ${copyUrl}`,
        time: 2,
        type: 'success',
        id: defaultMess,
      });
    }
  }, [defaultMess]);

  const handleSenURL = () => {
    let phone = inputVal.trim();
    if (inputVal.length >= 10) {
      handleSendSMS(phone, '_NOT_MOBILE')
        .then(() => {
          setisOk(true);
          openNotification({
            mess: 'We sent a URL to your mobile device!',
            time: 2,
            type: 'success',
            id: defaultMess,
          });
        })
        .catch((err) => {
          console.log('error', err);
          openNotification({
            mess: 'Error',
            time: 2,
            type: 'error',
            id: defaultMess,
          });
        });
    }
  };

  return (
    <section
      id="error"
      className="animate-bottom"
      style={{
        height: 'calc(var(--vh, 1vh) * 100)',
        overflowY: 'scroll',
        width: 'calc(100vw)',
        overflowX: 'hidden',
      }}
    >
      {isTheme === findTheme.DEALER_TRACK ? (
        <WrappLiteStyle className="content">
          <div
            className="photo"
            style={{
              position: 'relative',
              padding: '40px',
              maxWidth: '300px',
              width: '100%',
              margin: 'auto',
            }}
          >
            <img src={notMobileIcon} alt="img" />
          </div>
          <h5>DEVICE ERROR</h5>
          <h1>INCOMPATIBLE DEVICE OR BROWSER</h1>
          <p>
            We've detected that you're viewing this link from a desktop computer
            or other unsupported device
          </p>
          <p>
            The capture process must be performed with a mobile device that has
            camera and compatible browser.
          </p>
          <div
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '5px',
            }}
          >
            Please try one of the following to continue with the capture process
          </div>
          <p>
            A) Copy this session URL and paste it into another browser such as
            Chrome or Safari on this device.
          </p>
          <div style={{ margin: '0 15px 15px 0' }}>
            <PaveButton
              bgColor={PaveColor.primary_green}
              handleSubmit={handleCopyUrl}
              title=" Copy URL to clipboard"
            />
          </div>
          <p>
            B) or, enter your mobile phone number below so that we may send you
            a link to continue on your mobile device.
          </p>

          {isOk ? (
            <p>We sent a URL to your mobile device!</p>
          ) : (
            <div
              className="form"
              style={{ maxWidth: '992px', padding: '15px' }}
            >
              <div className="input " style={{ maxWidth: '666px' }}>
                <PhoneInput
                  pattern="[0-9]*"
                  inputMode="numeric"
                  international
                  defaultCountry="CA"
                  value={inputVal}
                  onChange={handleChange}
                  placeholder="Enter Mobile Number"
                />
              </div>
              <div style={{ marginTop: '20px' }}>
                <PaveButton
                  title=" Send Capture URL"
                  handleSubmit={handleSenURL}
                  bgColor={
                    submit ? PaveColor.primary_green : PaveColor.disabled
                  }
                />
              </div>
            </div>
          )}

          <div
            onClick={goBack}
            style={
              !mobileView
                ? {
                    textAlign: 'left',
                    position: 'relative',
                    left: '30px',
                    bottom: '2px',
                  }
                : {
                    textAlign: 'left',
                    position: 'relative',
                    left: '15px',
                    bottom: '2px',
                  }
            }
          >
            <div
              style={{
                maxWidth: '105px',
                background: 'rgb(172, 176, 183)',
                height: '35px',
                lineHeight: '40px',
                padding: '0 15px',
                color: '#fff',
                borderRadius: '20px',
              }}
            >
              <i
                className="fas fa-angle-left"
                style={{
                  margin: 'auto 10px auto 0',
                  color: '#fff',
                }}
              ></i>
              <span
                style={{
                  position: 'relative',
                  bottom: '3px',
                }}
              >
                Back
              </span>
            </div>
          </div>
        </WrappLiteStyle>
      ) : (
        <div className="content">
          <div
            className="photo"
            style={
              mobileView
                ? {
                    position: 'relative',
                    padding: '40px',
                    maxWidth: '300px',
                    width: '100%',
                    margin: 'auto',
                  }
                : {}
            }
          >
            <img src={notMobileIcon} alt="img" />
          </div>
          <h5>DEVICE ERROR</h5>
          {mobileView ? (
            <Fragment>
              <h1>YOU’RE USING CHROME ON IPHONE</h1>
              <p>
                Apple does not provide Chrome with sufficient device access.
                Please copy and paste this URL into Safari to proceed.
              </p>
              {mobileView && isTheme === findTheme.DEFAULT && (
                <p>Please copy your Session URL and open it on Safari</p>
              )}
            </Fragment>
          ) : (
            <Fragment>
              <h1>You're not mobile!</h1>
              <p>
                We've detected that you're viewing this link from a desktop
                computer or other unsupported device
              </p>
              {isLite && (
                <p>Please copy your Session URL and open it on Safari</p>
              )}
            </Fragment>
          )}

          {isOk && <p>We sent a URL to your mobile device!</p>}

          {!isOk && (
            <div
              className="form"
              style={{ maxWidth: '992px', padding: '15px' }}
            >
              <div style={!mobileView ? portraitStyle : {}}>
                <div className="input " style={{ maxWidth: '666px' }}>
                  <PhoneInput
                    pattern="[0-9]*"
                    inputMode="numeric"
                    international
                    defaultCountry="CA"
                    value={inputVal}
                    onChange={handleChange}
                    placeholder="Enter Mobile Number"
                  />
                </div>
                <div style={!mobileView ? customStyle_1 : customStyle_2}>
                  {isLite && (
                    <div style={{ padding: '15px 10px' }}>
                      <PaveButton
                        handleSubmit={handleCopyUrl}
                        bgColor={PaveColor.primary_green}
                        title="Copy URL"
                      />
                    </div>
                  )}
                  {mobileView && !isLite && isTheme === findTheme.DEFAULT && (
                    <div style={{ padding: '15px 10px' }}>
                      <PaveButton
                        handleSubmit={handleCopyUrl}
                        bgColor={PaveColor.primary_green}
                        title="Copy URL"
                      />
                    </div>
                  )}

                  <div
                    style={{
                      margin: 'auto 0',
                    }}
                  >
                    <PaveButton
                      title="Send Capture URL"
                      handleSubmit={handleSenURL}
                      bgColor={
                        submit ? PaveColor.primary_green : PaveColor.disabled
                      }
                    />
                  </div>
                </div>
              </div>
              <input style={{ opacity: '0' }} id="url-text" />
            </div>
          )}
          <div
            onClick={goBack}
            style={
              !mobileView
                ? {
                    textAlign: 'left',
                    position: 'relative',
                    left: '30px',
                    bottom: '2px',
                  }
                : {
                    textAlign: 'left',
                    position: 'relative',
                    left: '15px',
                    bottom: '2px',
                  }
            }
          >
            <div
              style={{
                maxWidth: '105px',
                background: 'rgb(172, 176, 183)',
                height: '35px',
                lineHeight: '40px',
                padding: '0 15px',
                color: '#fff',
                borderRadius: '20px',
              }}
            >
              <i
                className="fas fa-angle-left"
                style={{
                  margin: 'auto 10px auto 0',
                  color: '#fff',
                }}
              ></i>
              <span
                style={{
                  position: 'relative',
                  bottom: '3px',
                }}
              >
                Back
              </span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
const mapStateToProps = (state) => {
  return {
    sessionID: state.session.sessionKey,
    themeFrom: state.session.item.theme,
    userDetailsReducer: state.userDetailsReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    gaAction: bindActionCreators(gaActions, dispatch),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(NotMobile));

const portraitStyle = {
  justifyContent: 'center',
  flexWrap: 'wrap',
  padding: '5px 15px',
};
const customStyle_1 = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
};
const customStyle_2 = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
};

const WrappLiteStyle = styled.div`
  padding: 0 10px;
  p {
    padding: 0 !important;
  }
`;
